/* site-drawer.js — los drawers de toda la web (lote home-pulido, S5
   `feat/site-drawers`, 4 nov 2026; antes `pdp-drawer.js`). Sin dependencias,
   `defer` desde el layout. Marcado `snippets/site-drawer.liquid`; aspecto
   `assets/site-drawer.css`; el contrato entero en el relevo
   `docs/handoffs/feat-site-drawers.md`.
   · Disparadores: `<a href>` con `data-drawer-for` o `data-track="drawer:…"`.
   · Abrir solo cambia atributos: ni fetch ni transición. Esc, «× Close», el
     velo y atrás cierran; foco atrapado y de vuelta; el resto, `inert`.
   · Search: 120 ms, AbortController, caché, calentamiento, un replaceChildren.
   · Bag: una petición con `sections=site-bag,header-bag-count`; el número,
     optimista y de vuelta atrás si falla.
   `acaciasupplies.siteDrawer` (= `pdpDrawer`): open, close, isOpen, add,
   change, country, zone. */
(function (w, d) {
  'use strict';
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.siteDrawer) return;
  var box = d.querySelector('[data-site-drawers]');
  if (!box) return;
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var html = d.documentElement;
  var veil = box.querySelector('[data-site-veil]');
  var TRIG = 'a[data-drawer-for], a[data-track^="drawer:"]';
  var current = null, opener = null, pushed = false, skipPop = 0, dimmed = [];
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  /* Los de la ficha viven en su sección: se reúnen aquí para que el `inert`
     del resto no los alcance. Salen `hidden`: moverlos no pinta nada. */
  each(d.querySelectorAll('[data-site-drawer]'), function (el) { if (!box.contains(el)) box.appendChild(el); });

  function drawer(k) { return box.querySelector('[data-site-drawer="' + k + '"]'); }
  function keyOf(a) { return a.getAttribute('data-drawer-for') || (a.getAttribute('data-track') || '').slice(7); }
  function expand(k, on) {
    /* También el `<button>` «Add to bag» de la ficha (`data-track="drawer:bag"`). */
    each(d.querySelectorAll('[data-drawer-for], [data-track^="drawer:"]'), function (a) { if (keyOf(a) === k) a.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function shut(on) {
    if (on) {
      dimmed = [];
      each(d.body.children, function (el) { if (el !== box && !el.inert) { el.inert = true; dimmed.push(el); } });
    } else {
      dimmed.forEach(function (el) { el.inert = false; });
      dimmed = [];
    }
    /* `scrollbar-gutter: stable` guarda el hueco de una barra clásica; una
       barra con estilo propio no lo respeta, y entonces se rellena lo que
       la página haya ganado de ancho al quitarla. */
    var w0 = html.clientWidth;
    html.classList.toggle('site-dlock', on);
    html.style.setProperty('--sd-gutter', on ? Math.max(0, html.clientWidth - w0) + 'px' : '0px');
    if (veil) veil.hidden = !on;
  }
  function close(fromPop) {
    if (!current) return;
    var k = current.getAttribute('data-site-drawer');
    current.hidden = true;
    current = null;
    shut(false);
    expand(k, false);
    if (pushed && !fromPop) { skipPop++; w.history.back(); }
    pushed = false;
    var back = opener;
    opener = null;
    if (back && back.isConnected) back.focus({ preventScroll: true });
  }
  function open(k, from) {
    var el = drawer(k);
    if (!el) return false;
    if (current === el) return true;
    if (current) {
      expand(current.getAttribute('data-site-drawer'), false);
      current.hidden = true;
    } else {
      opener = from || d.activeElement;
      shut(true);
    }
    current = el;
    el.hidden = false;
    expand(k, true);
    try {
      if (pushed) w.history.replaceState({ drawer: k }, '');
      else { w.history.pushState({ drawer: k }, ''); pushed = true; }
    } catch (err) { console.warn('site-drawer: history', err); }
    (el.querySelector('[data-site-drawer-focus]') || el.querySelector('[data-site-drawer-close]') || el).focus({ preventScroll: true });
    if (k === 'country') paintCountries();
    if (k === 'bag') track('bag_view');
    return true;
  }
  w.addEventListener('popstate', function () {
    if (skipPop) { skipPop--; return; }
    if (current) close(true);
  });
  if (veil) veil.addEventListener('click', function () { close(); });
  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-site-drawer-close]')) { e.preventDefault(); close(); }
  });
  d.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(current.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select'), function (x) { return x.getClientRects().length; });
    if (!f.length) return;
    var a = d.activeElement, first = f[0], last = f[f.length - 1];
    if (!current.contains(a) || (e.shiftKey && a === first) || (!e.shiftKey && a === last)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  }, true);

  /* ── Disparadores ─────────────────────────────────────────────────────── */
  each(d.querySelectorAll(TRIG), function (a) {
    if (!drawer(keyOf(a))) return;
    a.setAttribute('role', 'button');
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('aria-controls', 'site-drawer-' + keyOf(a));
    a.setAttribute('aria-expanded', 'false');
  });
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(TRIG);
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var k = keyOf(a);
    if (!drawer(k)) return;
    e.preventDefault();
    /* La hoja del menú (móvil) se cierra antes: su «× Close» devuelve el foco a ☰. */
    var sheet = a.closest('[data-site-sheet]');
    if (sheet && !sheet.hidden) { var c = sheet.querySelector('[data-site-sheet-close]'); if (c) c.click(); }
    open(k, sheet ? d.activeElement : a);
  });
  d.addEventListener('keydown', function (e) {
    var a = e.key === ' ' && e.target.matches && e.target.matches(TRIG) ? e.target : null;
    if (a && a.getAttribute('role') === 'button') { e.preventDefault(); a.click(); }
  });

  /* ── Search ───────────────────────────────────────────────────────────── */
  var sq = box.querySelector('[data-search-q]');
  var out = box.querySelector('[data-search-results]');
  var blank = box.querySelector('template[data-search-empty]');
  var cache = {}, ctrl = null, timer = 0, warm = false;
  function sUrl(q) {
    return root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6';
  }
  function paint(nodes) { out.replaceChildren.apply(out, nodes); }
  function run(q) {
    if (ctrl) ctrl.abort();
    ctrl = null;
    var got = cache[q];
    if (!got) {
      ctrl = new AbortController();
      got = cache[q] = fetch(sUrl(q), { signal: ctrl.signal, credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      got.catch(function () { delete cache[q]; });
    }
    got.then(function (text) {
      if (sq.value.trim() !== q) return;
      var t = d.createElement('template');
      t.innerHTML = text;
      var res = t.content.querySelector('[data-predictive]');
      paint(res ? [res] : []);
    }).catch(function (err) {
      if (err.name !== 'AbortError') console.error('site-drawer: search failed', err);
    });
  }
  if (sq && out) {
    sq.addEventListener('input', function () {
      clearTimeout(timer);
      var q = sq.value.trim();
      if (!q) {
        if (ctrl) ctrl.abort();
        if (blank) paint([blank.content.cloneNode(true)]);
        return;
      }
      timer = setTimeout(function () { run(q); }, 120);
    });
    var heat = function (e) {
      var a = e.target.closest && e.target.closest(TRIG);
      if (warm || !a || keyOf(a) !== 'search') return;
      warm = true;
      fetch(sUrl(''), { credentials: 'same-origin' }).catch(function (err) { console.warn('site-drawer: warm-up', err); });
    };
    d.addEventListener('pointerover', heat);
    d.addEventListener('focusin', heat);
  }

  /* ── Bag ──────────────────────────────────────────────────────────────── */
  var SECTIONS = ['site-bag', 'header-bag-count'];
  function count() {
    var c = d.querySelector('[data-cart-count]');
    return c ? parseInt(c.textContent, 10) || 0 : 0;
  }
  function setCount(n) { each(d.querySelectorAll('[data-cart-count]'), function (c) { c.textContent = String(n); }); }
  function bagMsg(text) {
    var m = box.querySelector('[data-bag-msg]');
    if (m) m.textContent = text;
  }
  function track(name, extra) {
    var b = box.querySelector('[data-bag]');
    var p = { item_count: b ? +b.getAttribute('data-bag-count') : count(), state: b ? b.getAttribute('data-bag-state') : '' };
    for (var x in extra || {}) p[x] = extra[x];
    d.dispatchEvent(new CustomEvent('v10:track', { detail: { name: name, payload: p } }));
  }
  function swap(to, from, sel) {
    var a = to.querySelector(sel);
    a.replaceChildren.apply(a, [].slice.call(from.querySelector(sel).childNodes));
  }
  function apply(s) {
    if (!s || s['site-bag'] == null) throw new Error('no sections in the response');
    var n = /data-bag-count[^>]*>\s*(\d+)/.exec(s['header-bag-count'] || '');
    if (n) setCount(+n[1]);
    var t = d.createElement('template');
    t.innerHTML = s['site-bag'];
    var fresh = t.content.querySelector('[data-site-drawer="bag"]');
    var bag = drawer('bag');
    if (!fresh || !bag) throw new Error('no bag in the response');
    var f = d.activeElement;
    var line = f && bag.contains(f) && f.closest('[data-bag-line]');
    var mark = line ? [line.getAttribute('data-bag-line'), f.getAttribute('data-bag-q') === '0' ? 'x' : f.getAttribute('aria-label')] : null;
    swap(bag, fresh, '[data-site-drawer-title]');
    swap(bag, fresh, '[data-site-drawer-body]');
    if (current === bag && !bag.contains(d.activeElement)) {
      var back = null;
      if (mark) each(bag.querySelectorAll('[data-bag-line] button'), function (b) {
        if (!back && b.closest('[data-bag-line]').getAttribute('data-bag-line') === mark[0] && (b.getAttribute('data-bag-q') === '0' ? 'x' : b.getAttribute('aria-label')) === mark[1]) back = b;
      });
      (back || bag.querySelector('[data-site-drawer-close]')).focus({ preventScroll: true });
    }
  }
  function send(path, body, delta, from) {
    var before = count();
    setCount(Math.max(0, before + delta));
    bagMsg('');
    var json = !(body instanceof FormData);
    if (json) { body.sections = SECTIONS; body.sections_url = w.location.pathname; body = JSON.stringify(body); }
    else { body.append('sections', SECTIONS.join(',')); body.append('sections_url', w.location.pathname); }
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
        return j;
      });
    }).then(function (j) {
      apply(j.sections);
      open('bag', from);
      return j;
    }).catch(function (err) {
      setCount(before);
      console.error('site-drawer: the bag could not change', err);
      bagMsg('It couldn’t go in the bag. Try again.');
      open('bag', from);
      throw err;
    });
  }
  /* `data`: el FormData del formulario de compra, o { id, quantity }. */
  function add(data, opts) {
    var fd = data instanceof FormData ? data : null;
    if (!fd) { fd = new FormData(); fd.append('id', data.id); fd.append('quantity', data.quantity || 1); }
    return send('cart/add.js', fd, +(fd.get('quantity') || 1), (opts && opts.from) || d.activeElement);
  }
  function change(key, qty) {
    var had = 0;
    each(box.querySelectorAll('[data-bag-line]'), function (li) {
      if (li.getAttribute('data-bag-line') === key) had = +li.querySelector('.sd-line__n').textContent;
    });
    return send('cart/change.js', { id: key, quantity: qty }, qty - had, opener);
  }
  box.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-bag-q]');
    /* `aria-busy` y no `disabled`: un botón deshabilitado suelta el foco. */
    if (!q || q.getAttribute('aria-busy')) return;
    q.setAttribute('aria-busy', 'true');
    change(q.closest('[data-bag-line]').getAttribute('data-bag-line'), +q.getAttribute('data-bag-q')).catch(function () { q.removeAttribute('aria-busy'); });
  });

  /* Al pago: `checkout_start`; y la nota empieza por la línea del albarán. */
  box.addEventListener('submit', function (e) {
    if (e.target.querySelector('[name="checkout"]')) track('checkout_start');
    var note = e.target.querySelector('[data-bag-note]');
    if (!note) return;
    var G = 'Gift: no prices on the slip', rest = note.value.replace(G, '').replace(/^\s+/, '');
    var gift = e.target.querySelector('[data-bag-gift]');
    note.value = gift && gift.checked ? G + (rest ? '\n' + rest : '') : rest;
  });

  /* ── Ficha: Deliver to ────────────────────────────────────────────────── */
  var CK = 'as_country';
  function readCountry() {
    var v = null;
    try { v = w.localStorage.getItem(CK); } catch (err) { console.warn('site-drawer: localStorage unavailable', err); }
    if (!v) { var m = /(?:^|;\s*)as_country=([A-Z]{2})/.exec(d.cookie || ''); if (m) v = m[1]; }
    return v && /^[A-Z]{2}$/.test(v) ? v : null;
  }
  function zoneOf(iso) {
    var c = drawer('country');
    var r = c && c.querySelector('[data-pdp-country="' + iso + '"]');
    if (!r) return null;
    var a = function (n) { return r.getAttribute('data-' + n) || ''; };
    var num = function (v) { return /^\d+$/.test(v) ? +v : null; };
    return { iso: iso, name: a('name') || iso, tmin: num(a('transit-min')), tmax: num(a('transit-max')), rate: a('rate'), free: a('free') };
  }
  function money(cents) {
    var n = Math.round(+cents || 0), rest = n % 100;
    return String((n - rest) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (rest ? '.' + String(rest).padStart(2, '0') : '') + ' €';
  }
  function paintCountries() {
    var c = drawer('country'), dl = as.delivery, now = new Date();
    var sel = (as.deliveryCountry && as.deliveryCountry()) || null;
    if (!c) return;
    each(c.querySelectorAll('[data-pdp-country]'), function (r) {
      var iso = r.getAttribute('data-pdp-country'), z = zoneOf(iso), bits = [];
      var o = r.querySelector('[data-pdp-country-when]');
      if (dl && z && z.tmin != null && z.tmax != null) {
        var e = dl.estimate(now, dl.cutoff(), Math.min(z.tmin, z.tmax), Math.max(z.tmin, z.tmax), dl.holidays());
        if (e) bits.push(dl.range(e));
      }
      if (z && z.rate) bits.push(money(+z.rate * 100));
      if (o) o.textContent = bits.join(' · ');
      if (sel) r.setAttribute('aria-checked', iso === sel ? 'true' : 'false');
    });
  }
  var cd = drawer('country');
  if (cd) cd.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('[data-pdp-country]');
    if (!r) return;
    var iso = r.getAttribute('data-pdp-country');
    try { w.localStorage.setItem(CK, iso); } catch (err) { console.warn('site-drawer: localStorage unavailable', err); }
    d.cookie = CK + '=' + iso + '; path=/; max-age=31536000; samesite=lax';
    each(cd.querySelectorAll('[data-pdp-country]'), function (x) { x.setAttribute('aria-checked', x === r ? 'true' : 'false'); });
    d.dispatchEvent(new CustomEvent('pdp:country', { detail: zoneOf(iso) }));
    close();
  });

  /* ── Ficha: Ask about this piece ──────────────────────────────────────── */
  var ask = box.querySelector('form[data-pdp-ask]');
  if (ask) ask.addEventListener('submit', function (e) {
    if (!w.fetch || !w.FormData) return;
    e.preventDefault();
    var msg = ask.querySelector('[data-pdp-ask-msg]'), btn = ask.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(ask.getAttribute('action') || (root + 'contact'), { method: 'POST', body: new FormData(ask), credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        var done = d.createElement('p');
        done.className = 'pdp-dr__sent';
        done.setAttribute('role', 'status');
        done.textContent = 'Sent.';
        ask.parentNode.replaceChild(done, ask);
      })
      .catch(function (err) {
        console.error('site-drawer: the question could not be sent', err);
        if (msg) msg.textContent = 'It couldn’t be sent. Try again.';
        if (btn) btn.disabled = false;
      });
  });

  as.siteDrawer = as.pdpDrawer = {
    open: open,
    close: function () { close(); },
    isOpen: function () { return current ? current.getAttribute('data-site-drawer') : null; },
    add: add,
    change: change,
    country: readCountry,
    zone: zoneOf
  };
})(window, document);
